export default "__VITE_ASSET__c04f4aa8__"